import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { isTokenVerified, token, authServiceUnavailable } = useContext(AuthContext);

  if (isTokenVerified === false && token) {
    return authServiceUnavailable ? (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 text-center dark:bg-slate-950">
        <div className="max-w-md rounded-2xl border border-amber-200 bg-white p-6 shadow-sm dark:border-amber-900 dark:bg-slate-900">
          <h1 className="text-xl font-bold text-slate-950 dark:text-white">Pinngro is temporarily unavailable</h1>
          <p className="mt-2 text-slate-600 dark:text-slate-300">
            Your saved session has not been cleared. Please wait a moment and refresh this page.
          </p>
        </div>
      </div>
    ) : <LoadingSpinner fullScreen showLabel label="Checking your session…" />;
  }

  return isTokenVerified && token ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
